<template>
  <div class="card">
    <div class="card-body">
      <div class="info">
        <p
          class="info__description prefix-icon"
          :class="{
            'red-dot': mismatchList.length > 0,
            'green-dot': mismatchList.length === 0
          }"
        >
          {{ title }}
        </p>
        <p class="info__amount">{{ mismatchList.length }}</p>
      </div>
      <div
        v-if="mismatchList.length"
        class="view-prefix__toggle"
        @click="isExpandViewPrefixes = !isExpandViewPrefixes"
      >
        <p>View prefixes</p>
        <div class="icon-wrapper">
          <fa
            icon="chevron-down"
            :class="{ 'fa-rotate-180': isExpandViewPrefixes }"
          ></fa>
        </div>
      </div>
      <div
        class="view-prefix__content"
        :class="{ show: isExpandViewPrefixes }"
        :style="{
          'max-height': maxHeight
        }"
      >
        <ul>
          <li
            v-for="(item, index) of mismatchList"
            :key="index + item.route.prefix"
          >
            <span>
              {{ item.route.prefix }}
            </span>
            <span @click="showInfoModal(item)">+ info</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { MISMATCH_TYPE } from '../../constants/routingStatusConstant';

export default {
  name: 'MismatchCard',
  props: {
    title: {
      type: String,
      required: true
    },
    mismatchList: {
      type: Array,
      required: true
    }
  },
  computed: {
    maxHeight() {
      return this.isExpandViewPrefixes
        ? this.mismatchList.length * 3 + 'rem'
        : 0;
    }
  },
  data() {
    return {
      isExpandViewPrefixes: false
    };
  },
  methods: {
    ...mapMutations('routingStatusStore', [
      'set_isShowMismatchModal',
      'set_mismatchModalData'
    ]),

    showInfoModal(route) {
      const type =
        this.title.indexOf('ROA') > -1
          ? MISMATCH_TYPE.ROA
          : MISMATCH_TYPE.ROUTE_OBJECT;

      this.set_isShowMismatchModal(true);
      this.set_mismatchModalData({ type, data: route });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__description {
      font-size: 1.2rem;
      font-weight: 600;
    }

    &__amount {
      margin-top: 0.5rem;
      font-size: 2.5rem;
    }
  }

  .view-prefix__toggle {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    color: $text-light-blue;
    cursor: pointer;

    p {
      margin: 0;
      color: $text-light-blue;
    }

    .icon-wrapper {
      margin-left: 1rem;

      svg {
        transition: all 0.5s;
      }
    }
  }

  .view-prefix__content {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0.5s, opacity 1s 0.1s;

    &.show {
      opacity: 1;
    }

    ul {
      margin: 0;
    }

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 3rem;

      span:nth-child(2) {
        padding: 0.5rem 0 0.5rem 0.5rem;
        color: $text-light-blue;
        cursor: pointer;
      }
    }
  }
}
</style>
